var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.smAndUp)?_c('admin-navigation-drawer',{attrs:{"propDrawer":_vm.drawer},on:{"update:drawer":(v) => {
        _vm.drawer = v;
      }}}):_c('admin-bottom-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }